import CalculadoraMain from '../components/calculadora/CalculadoraMain';

function Calculadora() {
	return (
		<CalculadoraMain/>
	);
}

export default Calculadora;
